@use '../../styling/colors.scss' as *;
@use '../../styling/buttons.scss' as *;
@use '../../styling/typography.scss' as *;

.MultiselectDropdown {
  @extend %font-family-primary;

  color: $color-grey-B;
  position: relative;
  font-size: $font-size-normal;

  ul {
    padding: 0;
    list-style-type: none;
  }

  // The revealed dropdown content
  [role='listbox'] {
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 0;
    z-index: 1;
    margin: 0;
    padding: 0 0.5em;

    > li {
      padding: 1em;
    }
  }

  &[aria-expanded='true'] [role='listbox'] {
    background: $theme-color-background;
    border-radius: 4px;
    border: 1px solid $color-grey-C;
  }

  [role='option'] {
    padding: 0.5em;
    padding-left: 2em;
    position: relative;
    min-width: 100px;
    white-space: pre;
    cursor: pointer;

    &.highlighted {
      background: $color-grey-E;
    }

    [class^='CheckedIndicator'] {
      position: absolute;
      left: 0;
    }
  }

  .groupLabel {
    @extend %font-weight-semibold;

    border-bottom: 1px solid $color-grey-E;
    display: block;
    margin-bottom: 0.5em;
    padding-bottom: 0.5em;
  }
}

.MultiselecSingularDropdown {
  position: relative;
  display: inline-block;

  &[aria-expanded='true'] {
    span {
      button {
        background: $theme-color-secondary-button-hover;
      }
    }
  }

  span {
    button:hover {
      background: $theme-color-secondary-button-hover;
    }
  }

  [type='checkbox'] {
    // Basically hide the default checkbox
    appearance: none;
    position: absolute;

    // Use it as a placeholder for the indicator
    outline: none;
    height: 100%;
    width: 100%;
    margin: 0;
    z-index: -1;

    &:focus {
      outline: none;
    }
  }

  .dropdownWrapper {
    @extend %font-family-primary;

    position: absolute;
    top: 35px; // needs 35px to move dropdown menu to be exactly below highlighted button
    border-radius: 6px;
    background-color: $theme-dropdown-background-color;
    color: $theme-color-dropdown;
    width: 400px;
    max-height: 450px;
    z-index: 60;
    box-sizing: border-box;
    border: 1px solid $theme-color-dropdown-border-color;
    box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }

    &.narrowGap {
      top: 28px;
    }

    .maximumListWrapperStyle {
      display: flex;
      padding: 8px 16px;
      justify-content: center;
      text-align: center;
    }

    .externalQueryWrapperStyle {
      align-content: center;
      min-height: 32px;
    }
    
    :focus-visible {
      outline: none;
    }

    .searchWrapper {
      display: block;
      padding: 10px 16px 0 16px;
    }

    .clearSection {
      display: flex;
      padding: 8px 12px;
      justify-content: flex-end;
      border-top: 1px solid $theme-color-info-alert-border;

      &.justifySpaceBetween {
        align-items: center;
        justify-content: space-between;
      }

      button {
        padding: 0;
      }

      .clearWrapper {
        display: flex;
        padding: 7px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        height: 18px;
        width: 65px;

        svg {
          color: $theme-filter-icon-color;
        }
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 10px 0;
      font-size: $font-size-normal;
      max-height: 330px;
      overflow-y: auto;
      font-weight: normal;

      .highlighted{
        background: $theme-dropdown-hover-background;
      }

      .groupStyle {
        padding-left: 1em;
      }
    }

    li {
      align-items: center;
      display: flex;
      text-align: left;
      cursor: pointer;
      font-weight: $font-weight-semibold;
      padding: 8px 16px;

      .checkboxStyle {
        display: grid;
        grid-auto-flow: column;
        gap: 8px;
      }

      .textStyle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre;
      }

      &.GroupStyle {
        padding: 8px 8px 8px 32px;
      }

      &[aria-selected='true'] {
        color: $theme-color-text;
        font-weight: $font-weight-semibold;
      }

      &[aria-disabled='true'] {
        color: $theme-color-table-disabled-text;
      }

      span:not(:first-child) {
        padding-left: 8px;
      }
    }
  }
}

.NoSearchResult {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  text-align: center;
  align-items: center;
  padding: 7px 16px;
  margin-bottom: 12px;
}